export default {
  heading: 'Futura, sans-serif',
  subheading: 'Cabin Sketch, sans-serif',
  body: 'Futura Light, sans-serif',
  monospace: 'monospace',
  display: 'Teko, serif',
  googleFonts: [
    'Oswald:100,200,300,400,500,600,700,900,900',
    'Open Sans:100,200,300,400,500,600,700,900,900',
    'Permanent Marker',
    'Cabin Sketch: 400, 700'
  ],
  customFamilies: ['Futura Light', 'Futura', 'Silver Forte Grunge', 'Neue Haas Grotesk Thin'],
  customUrls: [
    'https://www.gonation.biz/fonts/futura-light/futura-light.css',
    'https://www.gonation.biz/fonts/silver-forte-grunge/silver-forte-grunge.css',
    'https://www.gonation.biz/fonts/neue-haas-grotesk-thin/neue-haas-grotesk-thin.css'
  ]
}
